import type { iconTypes } from "skedyul-ui/ui";
import { GetPageResponse } from "@store/features/crm/pageV2Slice";
import { DataType } from "skedyul-db/browser";
import { Params } from "../../helpers";
import { getByPath, getErrorForRowAndPath } from "./utils";

export const createMultiSelectCell = (
  field: {
    type: DataType;
    definition?: {
      options?: Array<{
        value: string;
        label: string;
        color?: string | null;
        icon?: string | null;
      }>;
      limitChoices?: number | null;
    } | null;
    label?: string;
  },
  _params: Params,
  accessorPath: string,
  pageData?: GetPageResponse,
) => {
  return {
    component: "MultiSelect" as const,
    generateProps: (
      row: Record<string, unknown>,
      _index: number,
      originalRow?: Record<string, unknown>,
    ) => {
      const current = getByPath(row, accessorPath);
      const original = originalRow
        ? getByPath(originalRow, accessorPath)
        : undefined;
      const toStringArray = (val: unknown): string[] => {
        if (Array.isArray(val)) return val.filter((v) => typeof v === "string");
        if (typeof val === "string" && val.length > 0) return [val];
        return [];
      };
      const fieldError = getErrorForRowAndPath(
        row,
        accessorPath,
        pageData || null,
      );
      return {
        id: accessorPath,
        value: toStringArray(current),
        originalValue: toStringArray(original),
        options:
          field.definition?.options?.map((o) => ({
            value: String(o.value ?? ""),
            label: String(o.label ?? ""),
            color: o.color,
            icon: o.icon as iconTypes | undefined,
          })) || [],
        limitChoices: field.definition?.limitChoices ?? undefined,
        errorMessage: fieldError?.message,
        handleValueChange: (_value: string[]) => {
          // handled by parent component via onFieldChange within table orchestration
        },
      };
    },
  };
};
